import React from 'react'
import Common from './../../api/common'
import Bottom from './../../api/bottom'
import {
    Form,
    Input,
    Row, Col,
    Select,
    Button, message
} from 'antd';
import './style.less';
import api from './../../api/api'
const { Option } = Select;
const c_scales_list = [{ "id": 1, "scale": "0-10\u4eba" }, { "id": 2, "scale": "11-50\u4eba" }, { "id": 3, "scale": "51-100\u4eba" }, { "id": 4, "scale": "101-200\u4eba" }, { "id": 5, "scale": "201-500\u4eba" }, { "id": 6, "scale": "501-1000\u4eba" }, { "id": 7, "scale": "1001-5000\u4eba" }, { "id": 8, "scale": "5001-10000\u4eba" }, { "id": 9, "scale": "10000\u4eba\u4ee5\u4e0a" }]
class consult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
            slider_val: 0,
            c_scales_list: [],//公司规模列表
            post_list: [],//职位列表
            ewm_img: '',//验证码地址
            captcha_code: '',//验证码code
        };
    }

    handleSubmit1 = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                api.sub_consultations({
                    job_name: values.job_id,
                    captcha_key: this.state.captcha_code,
                    captcha_code: values.captcha_key,
                    content: values.content,
                    corp_name: values.corp_name,
                    corp_scale: values.corp_scale,
                    email: values.email,
                    name: values.name,
                    phone: values.tel
                }).then(res => {

                    if (res.code === 0) {
                        message.success('提交成功');
                        this.props.form.resetFields()
                    }
                })
            }
        });
    };




    componentDidMount() {
        // api.get_post_list().then(res => {
        //     if (res.code === 0) {
        //         this.setState({ post_list: res.content || [] })
        //     }
        // })
        // api.get_c_scales_list().then(res => {
        //     if (res.code === 0) {
        //         this.setState({ c_scales_list: res.content })
        //     }
        // })
        this.setState({c_scales_list})
        this.reset_ewm()
    }
    reset_ewm = () => {
        api.post_photo_sms().then(res => {
            if (res.code === 0) {
                this.setState({
                    ewm_img: res.content.captcha_content,
                    captcha_code: res.content.captcha_key
                })
            }
        })
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 8 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 4,
                },
            },
        };

        return (<div className='consult'>
            <Common history={this.props.history} className='show'></Common>
            <h3>解决方案在线咨询</h3>
            <Form {...formItemLayout} onSubmit={this.handleSubmit1}>
                <Form.Item label="姓名">
                    {getFieldDecorator('name', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您的姓名！',
                            },
                        ],
                    })(<Input placeholder='请输入您的姓名' style={{ width: 420, lineHeight: '45px', height: 45 }} />)}
                </Form.Item>
                <Form.Item label="电话">
                    {getFieldDecorator('tel', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您的电话号码',
                            }
                        ],
                    })(<Input placeholder='请输入您的电话号码' type='number' style={{ width: 420, lineHeight: '45px', height: 45 }} />)}
                </Form.Item>
                <Form.Item label="邮箱">
                    {getFieldDecorator('email', {
                        rules: [
                            {
                                type: 'email',
                                message: '请填写正确的邮箱地址',
                            },
                            {
                                required: true,
                                message: '请填写您的邮箱地址!',
                            },
                        ],
                    })(<Input placeholder='请输入您的邮箱' style={{ width: 420, lineHeight: '45px', height: 45 }} />)}
                </Form.Item>
                <Form.Item label="企业名称">
                    {getFieldDecorator('corp_name', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您的企业名称！',
                            },
                        ],
                    })(<Input placeholder='请输入您的企业名称' style={{ width: 420, lineHeight: '45px', height: 45 }} />)}
                </Form.Item>
                <Form.Item label="职位">
                    {getFieldDecorator('job_id', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您的职位名称！',
                            },
                        ],
                    })(
                        // <Select placeholder='请选择您的职位' style={{ width: 300, height: 34, lineHeight: '34px' }}>
                        //     {this.state.post_list.map((res,id) => {
                        //         return <Option key={id} value={res.id}>{res.name}</Option>
                        //     })}

                        // </Select>
                        <Input placeholder='请输入您的职位名称' style={{ width: 420, lineHeight: '45px', height: 45 }} />
                    )}
                </Form.Item>
                <Form.Item label="企业规模">
                    {getFieldDecorator('corp_scale', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您的公司规模！',
                            },
                        ],
                    })(<Select placeholder='请选择您的公司规模' style={{ width: 300, height: 34, lineHeight: '34px' }}>
                        {this.state.c_scales_list.map((v, i) => {
                            return <Option key={i} value={v.id}>{v.scale}</Option>
                        })}

                    </Select>)}
                </Form.Item>
                <Form.Item label="您想咨询的问题是什么:">
                    {getFieldDecorator('content', {
                        rules: [
                            {
                                required: true,
                                message: '请填写您要咨询的问题',
                            },
                        ],
                    })(<Input.TextArea placeholder='请填写您要咨询的问题' rows={2} style={{ width: 420, lineHeight: '45px', verticalAlign: 'middle' }} />)}
                </Form.Item>
                <Form.Item label="验证码" >
                    <Row gutter={8}>
                        <Col span={8}>
                            {getFieldDecorator('captcha_key', {
                                rules: [{ required: true, message: '请填写验证码' }],
                            })(<Input />)}
                        </Col>
                        <Col span={12}>
                            <img src={this.state.ewm_img} onClick={() => {
                                this.reset_ewm()
                            }} style={{ width: 120 }} alt="" />
                        </Col>
                    </Row>
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                    <Button style={{ width: 100, height: 45, borderRadius: 0, fontSize: 18 }} type="primary" htmlType="submit">
                        提交
          </Button>
                </Form.Item>
            </Form>
            <div style={{ position: 'fixed', bottom: 0, width: '100%' }}><Bottom></Bottom></div>
        </div>)
    }
}
const WrappedRegistrationForm1212 = Form.create({ name: 'advanced_search' })(consult);
export default WrappedRegistrationForm1212;



// WEBPACK FOOTER //
// ./src/pages/solve_plan/consult.jsx